$(document).ready(function() {
    if ($('#MS__wrapper.iframe').length > 0) return;

    // Auto generate custom select from native select
    initCustomSelects();
});

function initCustomSelects() {
    // Find all native selects with class "custom-select-native"
    $('.custom-select-native').each(function() {
        const $nativeSelect = $(this);

        // Create wrapper
        const $wrapper = $('<div class="custom-select"></div>');

        // Copy data attributes from select to wrapper
        $.each(this.attributes, function() {
            if (this.name.startsWith('data-')) {
                $wrapper.attr(this.name, this.value);
            }
        });

        // Get selected option text - find option with selected attribute
        let selectedText = 'Select...';

        $nativeSelect.find('option').each(function(idx) {
            if (this.selected) {
                selectedText = this.text;
            }
        });

        // Create styled select button
        const $selectStyled = $('<div class="select-styled"></div>').text(selectedText);

        // Create options list
        const $selectOptions = $('<ul class="select-options"></ul>');

        // Generate options from native select
        $nativeSelect.find('option').each(function() {
            const $li = $('<li></li>')
                .text(this.text)
                .attr('data-value', this.value);

            // Mark as selected if this is the selected option
            if (this.selected) {
                $li.addClass('is-selected');
            }

            $selectOptions.append($li);
        });

        // Hide native select
        $nativeSelect.hide();

        // Insert wrapper before native select and add elements
        $nativeSelect.before($wrapper);
        $wrapper.append($nativeSelect).append($selectStyled).append($selectOptions);

        // Add event listeners
        addCustomSelectListeners($wrapper, $nativeSelect, $selectStyled, $selectOptions);
    });
}

// Function to pause Swiper scroll
function pauseSwiper() {
    // Find Swiper instance if it exists
    if (typeof Swiper !== 'undefined' && window.swiperInstance) {
        window.swiperInstance.disable();
    }

    // Add class to prevent scroll propagation to body/parent elements
    $('body').addClass('select-open');

    // Prevent document scroll
    $(document).on('wheel.selectscroll mousewheel.selectscroll DOMMouseScroll.selectscroll', function(e) {
        e.preventDefault();
    });
}

// Function to resume Swiper scroll
function resumeSwiper() {
    // Check if any select dropdown is still open
    if ($('.custom-select.is-open').length > 0) return;

    // Find Swiper instance if it exists
    if (typeof Swiper !== 'undefined' && window.swiperInstance) {
        window.swiperInstance.enable();
    }

    // Remove class
    $('body').removeClass('select-open');

    // Remove scroll prevention
    $(document).off('wheel.selectscroll mousewheel.selectscroll DOMMouseScroll.selectscroll');
}

function addCustomSelectListeners($wrapper, $nativeSelect, $selectStyled, $selectOptions) {
    // Toggle dropdown on click
    $selectStyled.on('click', function(e) {
        e.stopPropagation();

        // Close other dropdowns
        $('.custom-select.is-open').not($wrapper).removeClass('is-open');

        // Toggle current dropdown
        $wrapper.toggleClass('is-open');

        // Pause/resume Swiper based on dropdown state
        if ($wrapper.hasClass('is-open')) {
            pauseSwiper();
        } else {
            resumeSwiper();
        }
    });

    // Select option on click - use event delegation on the ul
    $selectOptions.on('click', 'li', function(e) {
        const $option = $(this);
        const value = $option.attr('data-value');

        e.stopPropagation();

        // Find matching native select option
        const $nativeOption = $nativeSelect.find('option[value="' + value + '"]');
        if ($nativeOption.length === 0) return;

        // Update selected state in custom select
        $selectOptions.find('li').removeClass('is-selected');
        $option.addClass('is-selected');

        // Update styled select text
        $selectStyled.text($option.text());

        // Update native select - remove selected from all, add to this one
        $nativeSelect.find('option').removeAttr('selected');
        $nativeOption.attr('selected', 'selected');
        $nativeSelect.val(value);

        // Trigger change event on native select using jQuery
        $nativeSelect.trigger('change');

        // Close dropdown and resume Swiper
        $wrapper.removeClass('is-open');
        resumeSwiper();
    });

    // Listen to change on native select
    $nativeSelect.on('change', function() {
        // Bạn có thể gọi API ở đây
        // $.ajax({ ... });
    });

    // Close dropdown when clicking outside
    $(document).on('click', function(e) {
        // Only close if click is outside the wrapper
        if (!$wrapper.is(e.target) && $wrapper.has(e.target).length === 0) {
            $wrapper.removeClass('is-open');
            resumeSwiper();
        }
    });

    // Close dropdown on ESC key
    $wrapper.on('keydown', function(e) {
        if (e.key === 'Escape') {
            $wrapper.removeClass('is-open');
            resumeSwiper();
        }
    });

    // Store function to update value from outside
    $nativeSelect.setSelectValue = function(value) {
        const $nativeOption = $nativeSelect.find('option[value="' + value + '"]');
        if ($nativeOption.length === 0) return $nativeSelect;

        // Find corresponding custom li
        const $customLi = $selectOptions.find('li[data-value="' + value + '"]');
        if ($customLi.length > 0) {
            // Update custom select UI
            $selectOptions.find('li').removeClass('is-selected');
            $customLi.addClass('is-selected');
            $selectStyled.text($customLi.text());
        }

        // Update native select
        $nativeSelect.find('option').removeAttr('selected');
        $nativeOption.attr('selected', 'selected');
        $nativeSelect.val(value);

        // Trigger change event
        $nativeSelect.trigger('change');

        return $nativeSelect; // For chaining
    };

    // Prevent scroll event propagation when hovering over select options
    $selectOptions.on('wheel mousewheel DOMMouseScroll', function(e) {
        e.stopPropagation();
    });
}